import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class HasUserInteractionsTask extends AbstractRequestTask {
  constructor(params, headers, token_wap, country_code) {
    super();
    this._config = getAppConfig();
    this._headers = headers;
    this._token_wap = token_wap;
    this._country_code = country_code
    this._params = {
      ...params,
    };
  }

  getMethod() {
    return "POST";
  }

  getEncType() {
    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    //return `${this._config.end_point_music}/middleware/cms/playlistDetail`;
    return `${getAppConfig().api_music_endpoint}/api/favorites/hasUserInteractions/appId/${getAppConfig().music_app_id}/token_wap/${this._token_wap}/ct/${this._country_code}/appVersion/${getAppConfig().music_app_version}`;
  }

  getParams() {
    const params = super.getParams();
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = '2.0.0';

    return { ...params, ...this._params };
  }

  getHeaders() {
    const headers = {
      ...this._headers
    };
    
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default HasUserInteractionsTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/HasUserInteractionsTask.js